(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggloid-best-seller"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var selector = ".best-sellers-wrapper .product-list";
  var paginationSel = ".best-sellers-wrapper .swiper-pagination";
  var nextSel = ".best-sellers-wrapper .swiper-button-next";
  var prevSel = ".best-sellers-wrapper .swiper-button-prev";

  var swiper = new Swiper(selector, {
    slidesPerView: 4,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    pagination: {
      el: paginationSel,
      clickable: true
    },
    navigation: {
      nextEl: nextSel,
      prevEl: prevSel
    },
    breakpoints: {
      0:   { slidesPerView: 1.2, spaceBetween: 20 },
      768: { slidesPerView: 2,   spaceBetween: 30 },
      1024:{ slidesPerView: 4,   spaceBetween: 40 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggloid-collection-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper('.custom-collection-swiper', {
    slidesPerView: 2,
    spaceBetween: 30,
    loop: true,
    autoplay: { delay: 4000, disableOnInteraction: false },
    navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
    breakpoints: {
      0: { slidesPerView: 2, spaceBetween: 15 },
      768: { slidesPerView: 2, spaceBetween: 20 },
      1024: { slidesPerView: 6, spaceBetween: 30 }
    },
    watchOverflow: true,  // if slides are less than slidesPerView, Swiper won’t break
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggloid-testi"] && !Shopify.designMode) return;
  try {
     document.addEventListener("DOMContentLoaded", function () { var selector = ".testimonials-swiper"; var paginationSel = ".testimonials-swiper .swiper-pagination"; var nextSel = ".testimonials-section .swiper-button-next"; var prevSel = ".testimonials-section .swiper-button-prev"; var swiper = new Swiper(selector, { slidesPerView: 3, spaceBetween: 30, loop: true, autoplay: { delay: 4000, disableOnInteraction: false }, pagination: { el: paginationSel, clickable: true }, navigation: { nextEl: nextSel, prevEl: prevSel }, breakpoints: { 0: { slidesPerView: 1, spaceBetween: 15 }, 768: { slidesPerView: 2, spaceBetween: 20 }, 1024:{ slidesPerView: 3, spaceBetween: 30 } } }); }); 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggloid-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  var selector = ".toggloid-video-swiper";
  var nextSel = ".toggloid-video-section .swiper-button-next";
  var prevSel = ".toggloid-video-section .swiper-button-prev";

  var swiper = new Swiper(selector, {
    slidesPerView: 5,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: nextSel,
      prevEl: prevSel
    },
    breakpoints: {
      0:   { slidesPerView: 1, spaceBetween: 15 },
      768: { slidesPerView: 2, spaceBetween: 20 },
      1024:{ slidesPerView: 5, spaceBetween: 30 }
    }
  });

  // Video play/pause logic
  document.querySelectorAll(".video-wrapper").forEach(function(wrapper) {
    const video = wrapper.querySelector("video");
    wrapper.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        wrapper.classList.add("playing");
      } else {
        video.pause();
        wrapper.classList.remove("playing");
        video.currentTime = 0; // video wapas start se
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
